<div class="row p-3">
    <div class="col-12 border-bottom mb-5 pb-2">
        <mat-card-title>Ticket Details</mat-card-title>
    </div>
    <div class="d-flex button-holder" style="
        position: absolute; z-index: 15;"
    >
      <button mat-fab tabindex="-1" class="extended-fab-button mr-2 bg-info" color="primary" (click)="markClosed.emit()">
        <mat-icon svgIcon="receipt-text-check"></mat-icon>
        <span class="extended-fab-button__text">Mark as solved</span>
      </button>
      <button mat-fab tabindex="-1" class="extended-fab-button mr-2" color="primary" (click)="exit.emit()">
        <mat-icon svgIcon="logout"></mat-icon>
        <span class="extended-fab-button__text">Exit</span>
      </button>
    </div>
    <div class="col-4">
        <mat-form-field class="w-100 mat-input-no-message">
            <mat-label>Created By</mat-label>
            <input type="text" matInput readonly [ngModel]="record.creator.fullName">
        </mat-form-field>
    </div>
    <div class="col-4">
        <mat-form-field class="w-100 mat-input-no-message" floatLabel="always">
            <mat-label>Ticket</mat-label>
            <input type="text" matInput readonly [value]="''" class="d-none">
            <a [attr.href]="record.ticketUrl" target="_blank">
                {{ record.ticketName }}
                <mat-icon svgIcon="open-in-new" class="ml-2" style="position: relative; top: 6px; margin-top: -10px;"></mat-icon>
            </a>
        </mat-form-field>
    </div>
    <div class="col-4">
        <mat-form-field class="w-100 mat-input-no-message">
            <mat-label>Date Created</mat-label>
            <input type="text" matInput readonly [value]="record.dateCreated | date: 'shortDate'">
        </mat-form-field>
    </div>
    <div class="col-12">
        <mat-form-field class="w-100">
            <textarea matInput readonly rows="6" [value]="record.text"></textarea>
        </mat-form-field>
    </div>
</div>